export enum SalaryAdvancePhase {
  Authorized = "Authorized",
  Paid = "Paid",
}
